import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "rp_token";
const PUBLIC_PATHS = ["/login", "/richiesta-preventivo"];

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      setToken(null);
      if (!PUBLIC_PATHS.includes(window.location.pathname)) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Si è verificato un errore, riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
}

export function fileUrl(u) {
  if (!u) return null;
  if (u.startsWith("http")) return u;
  return `${BACKEND}${u}${u.includes("?") ? "&" : "?"}token=${getToken()}`;
}

export const photoSrc = (p) => p.url || fileUrl(`/api/files/photo/${p.id}`);
export const docUrl = (d) => fileUrl(`/api/files/document/${d.id}`);
